// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2A7Vs","colMin":"styles_colMin__Dsdln","colCheckbox":"styles_colCheckbox__1rM4e"};